import type { CSSProperties } from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  ThreadsShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

import { ThreadsLogo } from '@phosphor-icons/react';
import { Envelope, LinkedinLogo, MetaLogo, RedditLogo, WhatsappLogo, XLogo } from '@phosphor-icons/react/dist/ssr';

interface Props {
  title: string;
  url: string;
  platform: string;
  className?: string;
  size?: number;
  color?: CSSProperties['color'];
  backgroundColor?: CSSProperties['backgroundColor'];
  borderStyle?: CSSProperties['borderStyle'];
  borderColor?: CSSProperties['borderColor'];
  borderWidth?: CSSProperties['borderWidth'];
  borderRadius?: CSSProperties['borderRadius'];
  padding?: CSSProperties['padding'];
}

const COMPONENTS_BY_PLATFORM = {
  email: { Button: EmailShareButton, Icon: Envelope },
  meta: { Button: FacebookShareButton, Icon: MetaLogo },
  x: { Button: TwitterShareButton, Icon: XLogo },
  threads: { Button: ThreadsShareButton, Icon: ThreadsLogo },
  linkedIn: { Button: LinkedinShareButton, Icon: LinkedinLogo },
  reddit: { Button: RedditShareButton, Icon: RedditLogo },
  whatsApp: { Button: WhatsappShareButton, Icon: WhatsappLogo },
};

export const PlatformShareButton = ({
  title,
  url,
  platform,
  className,
  color,
  backgroundColor,
  borderColor,
  borderStyle,
  borderRadius,
  borderWidth,
  padding,
  size = 20,
}: Props) => {
  const components = COMPONENTS_BY_PLATFORM[platform];
  if (!components) {
    return null;
  }

  return (
    <components.Button
      className={className}
      title={title}
      url={url}
      style={{
        backgroundColor,
        borderStyle,
        borderColor,
        borderWidth,
        borderRadius,
        padding,
      }}
    >
      <components.Icon size={size} color={color} />
    </components.Button>
  );
};
